<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import axios from 'axios';

    @Component({
        props: {
            accept: { type: String, default: null },
            ttl: { type: Number, default: null },
            skipConfirmation: { type: Boolean, default: false },
            hideProgress: { type: Boolean, default: false },
        }
    })
    export default class FileUploader extends Vue {
        file: File | null = null;
        uploadPercentage: number = 0;
        uploading: boolean = false;

        handleFileSelected() {
            const fileInput = this.$refs.fileInput as HTMLInputElement;

            if (fileInput && fileInput.files) {
                this.file = fileInput.files[0];
                this.$emit('selected', this.file);
            }

            if (this.$props.skipConfirmation) {
                this.submitFile();
            }
        }

        clickFileInput() {
            const fileInput = this.$refs.fileInput as HTMLInputElement;
            fileInput.click();
        }

        formatFileSize(size: number) {
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (size == 0) return '0 Byte';
            const i = parseInt(Math.floor(Math.log(size) / Math.log(1024)).toString());
            return Math.round(size / Math.pow(1024, i)) + ' ' + sizes[i];
        }

        submitFile() {
            if (!this.file) return;

            const formData = new FormData();
            formData.append('file', this.file);

            this.uploading = true;

            axios.post('/blobs/v2/upload/', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'ttl': this.$props.ttl
                },
                onUploadProgress: (event) => {
                    this.uploadPercentage = Math.round((event.loaded / event.total) * 100);
                    this.$emit('progress', this.uploadPercentage);
                }
            })
                .then((response) => {
                    this.$emit('uploaded', response.data);
                    this.reset();
                })
                .catch(() => {
                    this.uploading = false;
                    this.$emit('failed');
                });
        }

        reset() {
            this.file = null;
            this.uploadPercentage = 0;
            this.uploading = false;
            // Reset the file input so the user can select the same file again if needed
            const fileInput = this.$refs.fileInput as HTMLInputElement | undefined;

            if (fileInput) {
                fileInput.value = '';
            }
        }

        cancelUpload() {
            this.$emit('unselected');
            this.reset();
        }
    }
</script>

<template>
    <div>
        <div v-if="!file">
            <input type="file" ref="fileInput" class="custom-file-input" @change="handleFileSelected" :accept="$props.accept" style="display: none;">
            <div @click="clickFileInput">
                <slot>
                    <button class="btn btn-outline-secondary">Upload file</button>
                </slot>
            </div>
        </div>

        <div v-if="!$props.skipConfirmation && file && !uploading">
            <slot name="file">
                <p>
                    Selected file: <strong>{{ file.name }}</strong> ({{ formatFileSize(file.size) }}).
                    Please confirm to proceed or cancel to select a different file.
                </p>
            </slot>
            <button class="btn btn-primary" @click="submitFile">Confirm</button>
            <button class="btn btn-secondary" @click="cancelUpload">Cancel</button>
        </div>

        <div v-if="!$props.hideProgress && file && uploading">
            <p>Uploading: {{ uploadPercentage }}%</p>
        </div>
    </div>
</template>